import { useState } from 'react';
import { createPortal } from 'react-dom';
import { plantDisplayName } from './nameUtils';

function MarkAcquiredModal({ plant, onSuccess, onCancel }) {
  const [form, setForm] = useState({
    acquisition_date: plant.acquisition_date || '',
    cost: plant.cost != null ? String(plant.cost) : '',
    acquisition_notes: plant.acquisition_notes || '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const r = await fetch(`/plants/${plant.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          status: 'collection',
          acquisition_date: form.acquisition_date.trim() || null,
          cost: form.cost.trim() ? parseFloat(form.cost.trim()) : null,
          acquisition_notes: form.acquisition_notes.trim() || null,
        }),
      });
      if (!r.ok) {
        const err = await r.json();
        throw new Error(err.detail || 'Failed to mark as acquired');
      }
      const updated = await r.json();
      onSuccess(updated);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={!saving ? onCancel : undefined}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>Mark as acquired</h2>
            <p className="modal-subtitle">
              {plantDisplayName(plant)}
            </p>
          </div>
          <button type="button" className="btn btn-icon" onClick={onCancel} aria-label="Close" title="Close" disabled={saving}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label className="form-label">Acquisition date</label>
            <input
              type="date"
              name="acquisition_date"
              value={form.acquisition_date}
              onChange={handleChange}
              className="form-input"
            />
          </div>
          <div className="form-field">
            <label className="form-label">Cost</label>
            <input
              type="number"
              name="cost"
              value={form.cost}
              onChange={handleChange}
              className="form-input"
              step="0.01"
              min="0"
              inputMode="decimal"
            />
          </div>
          <div className="form-field">
            <label className="form-label">Notes</label>
            <textarea
              name="acquisition_notes"
              value={form.acquisition_notes}
              onChange={handleChange}
              className="form-input form-textarea"
              rows="3"
            />
          </div>
          {error && <p className="error">{error}</p>}
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Convert to collection'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default MarkAcquiredModal;
